const {jQuery: $} = window;
import Utils from "./utils.class";
import Cookies from 'js-cookie';

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #builder;
    #config;
    #scrollOffset;
    #scrollSpeed;
    #utils;
    #$admin;
    #root;

    #counter;

    constructor(
        config,
        builder,
        utils,
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;
        this.#root = document.querySelector(":root");

        this.#scrollOffset = 0;
        this.#scrollSpeed = 750;
        this.$html = $('html');

        this.$body = $('body');
        this.$main = $('.site-wrapper');
        this.$header = $('header.site_header');
        this.#$admin = $('#wpadminbar');
        this.#counter = $('.counter__number');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", "1");
        }

        Utils.log("Theme Config:", config);
    }

    __onReady() {
        const me = this;

        Utils.log("Theme Ready");

        $(window).on('hashchange', function (e) {
            Utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (!Utils.scrollToHash(location.hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').on('click', function (e) {
            let $el = $(this);

            if ($el.attr('href') && $el.attr('href').search('#') === 0) {
                let hash = $el[0].hash;

                if (!Utils.scrollToHash(hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        let socialMenu = [];
        if(this.#config.social.linkedin) {
            socialMenu.push(`<a href='${this.#config.social.linkedin}' target='_blank'><i class='fa fa-linkedin'></i></a>`)
        }

        if(this.#config.social.twitter) {
            socialMenu.push(`<a href='${this.#config.social.twitter}' target='_blank'><i class='fa fa-twitter'></i></a>`)
        }

        if(this.#config.social.facebook) {
            socialMenu.push(`<a href='${this.#config.social.facebook}' target='_blank'><i class='fa fa-facebook'></i></a>`)
        }

        if(this.#config.social.instagram) {
            socialMenu.push(`<a href='${this.#config.social.instagram}' target='_blank'><i class='fa fa-instagram'></i></a>`)
        }

        $("#menu-wrapper").mmenu(
            {
                "navbar": {
                    "title": mmtitle,
                },
                "navbars": [
                    {
                        "position": "top",
                        "content": [
                            "searchfield"
                        ]
                    }
                ],
                "extensions": [
                    "pagedim-black",
                    "theme-dark",
                    "position-front",
                    "position-right"
                ],
                "searchfield": {
                    "search": false,
                },
                "iconbar": {
                    "add": true,
                    "size": 40,

                    "top": [
                        "<a href='/'><i class='fa fa-home'></i></a>",
                        "<a href='/#/'><i class='fa fa-user'></i></a>"
                    ],
                    "bottom": socialMenu
                },
                backButton: {},
                classNames: {
                    fixedElements: {
                        fixed: "fix",
                        sticky: "stick"
                    }
                }
            }, {
                offCanvas: {
                    pageNodetype: 'div#page.site-wrapper'
                },
                "searchfield": {
                    "form": {
                        "method": 'GET',
                        "action": this.#config.homeURL
                    },
                    "input": {
                        "name": 's'
                    }
                }
            }
        );
    }

    __onLoad() {
        const me = this;
        const RC = window.kmdgResourceCenter;

        Utils.log("Theme Load");
        this.#$admin = $('#wpadminbar');

        $(window).trigger("resize");

        this.$header.addClass('fixed');

        let top = 1; // Trigger on any scrolling
        $(document).scroll(Utils.debounce(250, true, function () {
            let scrollPos = $(document).scrollTop();
            if (top && scrollPos >= top) {
                $('.site_header').addClass('scrolled');
            } else if (top && scrollPos < top) {
                $('.site_header').removeClass('scrolled');
                setTimeout(() => me.#updateCssHeaderHeight(), 1000);
            }
        }));

        if (location.hash) {
            Utils.log("Scroll to Section Load");

            setTimeout(function () {
                Utils.scrollToHash(location.hash, null, me.scrollOffset, me.#scrollSpeed);

            }, 300);
        }

        setTimeout(function () {
            $(window).trigger("resize");
        }, 1000);

        $('.search-bar .search-button').on('click', function () {
            $(this).parent().toggleClass('open');
        });

        $(document).on("gform_confirmation_loaded", function (e, form_id) {
            Utils.log("[RC] Confirmation Loaded:", form_id);

            if (RC.form == form_id) {

                $(window).trigger('kmdg_rc_form_submitted', [$(`#gform_${form_id}`).find("input[type=email]").val(), form_id, function (response) {
                    // Generate thank you page
                    Utils.log("[RC] Download:", response);

                    $(`#gform_confirmation_message_${form_id}`).html(response);
                    window.location.hash = "success";
                }]);
            }
        });

        $('a:not([data-featherlight])').each(function(i, el) {
            const url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags
            if(url) {
                if(url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)){
                    const id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube-nocookie.com/embed/" + id + "?rel=0&amp;autoplay=1" );

                    $(el).featherlight();
                } else if (url.indexOf("vimeo.com/") >= 0 || url.indexOf("player.vimeo.com/") >= 0) {
                    const id = Utils.vimeoParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://player.vimeo.com/video/" + id + "?rel=0&amp;autoplay=1" );

                    $(el).featherlight();
                }
            }
        });

        $(".resource--featured-company").each(function () {
            $(this).on("click", function (e) {
                e.preventDefault();
                RC.fn.setHashData('page', 1);
                RC.fn.setHashData($(this).attr('data-name'), $(this).attr('data-value'));
                RC.fn.getPosts();
            })
        });

        $(".resource--filter-reset").on("click", function (e) {
            window.location.hash="";
        });
    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }

    activatePlayer() {
        // TODO: Implement video platform integration
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        if (this.#$admin.length > 0) {
            return this.$header.outerHeight() + this.#$admin.outerHeight();
        }

        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        return this.#scrollOffset + this.headerHeight + subNav;
    }

    #updateCssHeaderHeight() {
        this.#root.style.setProperty('--header-height', this.headerHeight + "px");
    }
}